"use client";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { changeCustom, selectCustom } from "../../lib/redux/resumeSlice";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

export const CustomForm = () => {
  const dispatch = useAppDispatch();
  const custom = useAppSelector(selectCustom);

  const handleCustomDescriptionsChange = (descriptions: string[]) => {
    dispatch(changeCustom({ field: "descriptions", value: descriptions }));
  };

  return (
    <Card className="bg-white border-2 border-gray-800 shadow-lg">
      <CardHeader className="bg-gray-900 text-white">
        <CardTitle className="text-lg font-semibold">Additional Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="custom-descriptions" className="text-black font-semibold">Additional Sections</Label>
          <Textarea
            id="custom-descriptions"
            value={custom.descriptions.join('\n')}
            onChange={(e) => {
              const descriptions = e.target.value.split('\n').filter(line => line.trim());
              handleCustomDescriptionsChange(descriptions);
            }}
            placeholder="• Volunteer Work: Habitat for Humanity (2019-2021)
• Awards: Employee of the Year 2022
• Publications: 'Modern Web Development' - Tech Journal 2023
• Languages: English (Native), Spanish (Fluent), French (Intermediate)"
            rows={6}
            className="border-2 border-gray-300 bg-white text-black placeholder-gray-500 hover:border-black focus:border-black transition-colors resize-none"
          />
          <p className="text-sm text-gray-600">
            Add any additional sections like volunteer work, awards, publications, languages, etc. Enter each item on a new line starting with a bullet point (•)
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
